import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import { getFormInputProps } from "util/forms";
import { LayoutCsv, withUnique } from "./common";
import type { CsvValue, SetupValueProps } from "../types";
import { FormField } from "../../types";

const CsvInt = (props: SetupValueProps<CsvValue>) => {
    const {
        values,
        setFieldValue,
        handleChange,
        handleBlur,
        onChange,
        isValid,
        initialValues,
        ...restProps
    } = props;

    const handleAdd = () => {
        onChange!([
            ...values[FormField.SetupValue].value,
            values[FormField.SetupInputValue]
        ]);
        setFieldValue(
            FormField.SetupInputValue,
            initialValues.setupInputValue,
            true
        );
    };

    return (
        <LayoutCsv
            {...props}
        >
            <TextField
                {...getFormInputProps(FormField.SetupInputValue, restProps)}
                fullWidth
                type='number'
                size='small'
                name={FormField.SetupInputValue}
                value={values[FormField.SetupInputValue]}
                label='Add CSV Int Value'
                onChange={handleChange}
                onBlur={handleBlur}
                InputProps={{
                    endAdornment: (
                        <IconButton
                            color='primary'
                            size='small'
                            disabled={!isValid}
                            onClick={handleAdd}
                        >
                            <SendIcon />
                        </IconButton>
                    )
                }}
            />
        </LayoutCsv>
    );
};

export default withUnique(CsvInt);
